import React, { useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Avatar, Box, ButtonGroup, Typography, useMediaQuery, Card, CardHeader, CardContent, CardActions, CardActionArea, Rating, Button, Collapse, useTheme, InputBase, IconButton, Divider, styled, List, ListItem, ListItemAvatar, ListItemText, ListItemSecondaryAction } from "@mui/material"
import Header from './Header'
import { UserAuth } from '../context/AuthContext'
import { useNavigate, useParams } from 'react-router-dom'
import { motion } from "framer-motion";
import Grid from '@mui/material/Unstable_Grid2';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import TokenContext from '../context/TokenContext';

import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { confirmarOrechazarAsignacion } from '../Redux/asignaciones'
import { fetchFormacion, fetchHitos, fetchTareas, limpiarEstados } from '../Redux/asignacionesActividades'
import { COLUMNSFORMACION, COLUMNSHITOS, COLUMNSTAREAS } from '../columnas/columnasAsignacionesActividades'

import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import CircularProgress from '@mui/material/CircularProgress';
import TablaAsignaciones from './tablas/TablaAsignaciones'
import TablaHitos from './tablas/TablaHitos'
import ModalActividadesHitos from './modales/ModalActividadesHitos'

const AceptacionAsignacionActividades = () => {
    const dispatch = useDispatch()
    const theme = useTheme()
    const navigate = useNavigate();
    const token = useContext(TokenContext)
    const { id } = useParams()
    const { empleado } = UserAuth()
    const [valuePrimerTab, setValuePrimerTab] = React.useState('1'); //value del tablist
    const [accepted, setAccepted] = React.useState(false);
    const [rejected, setRejected] = React.useState(false);

    const [openModal, setOpenModal] = React.useState(false);
    const [hitoId, setHitoId] = React.useState('')
    //HITOS
    const [hitos, setHitos] = React.useState([])
    const [loadingHitos, setLoadingHitos] = React.useState(false)
    const hitosSelector = useSelector(store => store.asignacionesActividades.hitos)
    const getHITOSselector = useSelector(store => store.asignacionesActividades.getHitos)

    const [formacion, setFormacion] = React.useState([])
    const [loadingFormacion, setLoadingFormacion] = React.useState(false)
    const formacionSelector = useSelector(store => store.asignacionesActividades.formacion)
    const getFORMACIONselector = useSelector(store => store.asignacionesActividades.getFormacion)

    const [tareas, setTareas] = React.useState([])
    const [loadingTareas, setLoadingTareas] = React.useState(false)
    const tareasSelector = useSelector(store => store.asignacionesActividades.tareas)
    const getTAREASselector = useSelector(store => store.asignacionesActividades.getTareas)

    React.useEffect(() => {
        // Función de limpieza
        return () => {
            dispatch(limpiarEstados());
        };
    }, []);

    React.useEffect(() => {
        if (token && empleado) {
            dispatch(fetchHitos(token, id))
            dispatch(fetchFormacion(token, id, empleado.usuarioPortalRh))
            dispatch(fetchTareas(token, id, empleado.usuarioPortalRh))
        }
    }, [id, token, empleado])
    //HITOS
    React.useEffect(() => {
        if (hitosSelector?.length > 0 && getHITOSselector === true) {
            var array = []
            hitosSelector.forEach(element => {
                var objeto = {
                    id: element.new_hitodelaproducciondecontenidoid,
                    new_fechavencimiento: element["new_fechavencimiento@OData.Community.Display.V1.FormattedValue"],
                    statuscode: element["statuscode@OData.Community.Display.V1.FormattedValue"],
                    new_nombre: element.new_nombre
                }
                array.push(objeto)
            });
            setHitos(array)
            setLoadingHitos(true)
        } else if (hitosSelector?.length == 0 && getHITOSselector === true) {
            setLoadingHitos(true)
        }
    }, [hitosSelector, id])

    //FORMACION DOCENTE
    React.useEffect(() => {
        if (formacionSelector?.length > 0 && getFORMACIONselector === true) {
            var array = []
            formacionSelector.forEach(element => {
                var objeto = {
                    id: element.new_hitodelaproducciondecontenidoid,
                    new_name: element.new_name,
                    new_grado: element.new_grado,
                    new_subdisciplina: element.new_subdisciplina,
                    cr879_tipodeexperienciadeaprendizaje: element["cr879_tipodeexperienciadeaprendizaje@OData.Community.Display.V1.FormattedValue"],
                    new_tipodeformacion: element["new_tipodeformacion@OData.Community.Display.V1.FormattedValue"]
                }
                array.push(objeto)
            });
            setFormacion(array)
            setLoadingFormacion(true)
        } else if (formacionSelector?.length == 0 && getFORMACIONselector === true) {
            setLoadingFormacion(true)
        }
    }, [formacionSelector, id])

    //TAREAS
    React.useEffect(() => {
        if (tareasSelector?.length > 0 && getTAREASselector === true) {
            var array = []
            tareasSelector.forEach(element => {
                var objeto = {
                    id: element.activityid,
                    scheduledend: element["scheduledend@OData.Community.Display.V1.FormattedValue"],
                    scheduledstart: element["scheduledstart@OData.Community.Display.V1.FormattedValue"],
                    subject: element.subject,
                    new_materia: element.new_materia
                }
                array.push(objeto)
            });
            setTareas(array)
            setLoadingTareas(true)
        } else if (tareasSelector?.length == 0 && getTAREASselector === true) {
            setLoadingTareas(true)
        }
    }, [tareasSelector, id])

    const handleVolverAtras = () => {
        navigate('/asignaciones');
    };

    const handleChangePrimerTAB = (event, newValue) => {
        setValuePrimerTab(newValue);
    };

    const handleAccept = () => {
        setAccepted(true);
        setRejected(false);
        dispatch(confirmarOrechazarAsignacion(token, id, 100000000))
            .then(() => {
                // Promesa cumplida, redirige a la ruta '/asignaciones'
                navigate('/asignaciones');
            })
            .catch((error) => {
                // Manejar el error de la promesa si es necesario
                console.log(error)
            });
    };

    const handleReject = () => {
        setAccepted(false);
        setRejected(true);
        dispatch(confirmarOrechazarAsignacion(token, id, 100000001))
            .then(() => {
                // Promesa cumplida, redirige a la ruta '/asignaciones'
                navigate('/asignaciones');
            })
            .catch((error) => {
                // Manejar el error de la promesa si es necesario
                console.log(error)
            });
    };

     //======|| handlers del modal ACTIVIDADES DEL HITO ||====== //
     const handleCloseModal = () => {
        setOpenModal(false)
        setHitoId('')
    };

    const handleOpenModal = (id) => {
        setOpenModal(true);
        setHitoId(id)
    };
    //======================================================= //

    return (
        <motion.div
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -100 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
        >
            <Box
                m="1.5rem 2.5rem"
            >
                <Button variant="outlined" onClick={handleVolverAtras} sx={{ mb: 4 }} color='secondary'>
                    <IconButton color='secondary'>
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography color='secondary'>Volver atrás</Typography>
                </Button>

                <Header title={"Aceptación de asignación - Actividades"} subtitle="" />
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12}>
                        <TabContext value={valuePrimerTab}>
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'center',
                            }}>
                                <TabList
                                    aria-label="scrollable force tabs example"
                                    onChange={handleChangePrimerTAB} variant="scrollable"
                                    scrollButtons="auto"
                                    allowScrollButtonsMobile
                                    textColor="secondary"
                                    indicatorColor="secondary"
                                >
                                    <Tab label="Hitos de la actividad" value="1" sx={{ fontWeight: 'bold', fontSize: '16px' }} />
                                    <Tab label="Formación docente" value="2" sx={{ fontWeight: 'bold', fontSize: '16px' }} />
                                    <Tab label="Tareas de la actividad" value="3" sx={{ fontWeight: 'bold', fontSize: '16px' }} />
                                </TabList>
                            </Box>
                            <TabPanel value="1">
                                {
                                    !loadingHitos ? (
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                width: '100%',
                                                height: '100%',
                                                py: 2
                                            }}>
                                            <CircularProgress color="secondary" />
                                        </Box>
                                    ) :
                                        hitos.length > 0 ? (
                                            <>
                                                <TablaHitos columnas={COLUMNSHITOS} lineas={hitos} acciones={true} handleOpen={handleOpenModal} />
                                            </>
                                        ) :
                                            <Alert severity="info">
                                                <AlertTitle>Info</AlertTitle>
                                                No existen registros de — <strong>Hitos</strong>.
                                            </Alert>
                                }
                            </TabPanel>
                            <TabPanel value="2">
                                {
                                    !loadingFormacion ? (
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                width: '100%',
                                                height: '100%',
                                                py: 2
                                            }}>
                                            <CircularProgress color="secondary" />
                                        </Box>
                                    ) :
                                        formacion.length > 0 ? (
                                            <>
                                                <TablaAsignaciones columnas={COLUMNSFORMACION} lineas={formacion} />
                                            </>
                                        ) :
                                            <Alert severity="info">
                                                <AlertTitle>Info</AlertTitle>
                                                No existen registros de — <strong>Formación docente</strong>.
                                            </Alert>
                                }
                            </TabPanel>
                            <TabPanel value="3">
                                {
                                    !loadingTareas ? (
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                width: '100%',
                                                height: '100%',
                                                py: 2
                                            }}>
                                            <CircularProgress color="secondary" />
                                        </Box>
                                    ) :
                                        tareas.length > 0 ? (
                                            <>
                                                <TablaAsignaciones columnas={COLUMNSTAREAS} lineas={tareas} />
                                            </>
                                        ) :
                                            <Alert severity="info">
                                                <AlertTitle>Info</AlertTitle>
                                                No existen registros de — <strong>Tareas</strong>.
                                            </Alert>
                                }
                            </TabPanel>
                        </TabContext>
                    </Grid>


                    <Grid item xs={12} sm={12}>
                        <Box display="flex" flexDirection="column" alignItems="center">
                            <Typography variant="h6" sx={{ mt: 2, mb: 2 }}>¿Deseas aceptar o rechazar la asignación?</Typography>
                            <ButtonGroup>
                                <Button
                                    variant={accepted ? 'contained' : 'outlined'}
                                    onClick={handleAccept}
                                    disabled={accepted || rejected}
                                    color="success"
                                >
                                    Aceptar
                                </Button>
                                <Button
                                    variant={rejected ? 'contained' : 'outlined'}
                                    onClick={handleReject}
                                    disabled={accepted || rejected}
                                    color="error"
                                >
                                    Rechazar
                                </Button>
                            </ButtonGroup>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
            <ModalActividadesHitos open={openModal} handleClose={handleCloseModal} hitoId={hitoId} />
        </motion.div>
    )
}

export default AceptacionAsignacionActividades